var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wdb100"
  }, [_c('el-select', {
    ref: "remoteSelect",
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getRemoteData,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder
    },
    on: {
      "clear": function clear($event) {
        return _vm.getRemoteData('');
      },
      "focus": function focus($event) {
        return _vm.getRemoteData('');
      },
      "change": _vm.handleChange
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, _vm._l(_vm.dataList, function (item, index) {
    return _c('el-option', {
      key: "client-code-remote-".concat(index, "-").concat(item.clientCode),
      attrs: {
        "label": item.clientCode,
        "value": item.clientCode
      }
    }, [_c('div', [_vm._v(_vm._s(item.clientCode) + "-" + _vm._s(item.companyName))])]);
  }), 1), _c('Autofill', {
    ref: "autofillRef",
    attrs: {
      "showItems": _vm.showItems
    },
    on: {
      "selectedInfo": _vm.selectedInfo
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }